'use strict';

const ContainerRepository = require('data/domain/repository/container/index');
const ContentAPI = require('data/infra/api/content/index');
const ContentFactory = require('data/domain/factory/content/index');
const ContentRepository = require('data/domain/repository/content/index');

class ContentAddService {
    constructor({project, name, uri, storageObjectId, thumbnailURI, uploaded, parentContainer} = {}){
        this._project = project;
        this._name = name;
        this._uri = uri;
        this._storageObjectId = storageObjectId;
        this._thumbnailURI = thumbnailURI;
        this._uploaded = uploaded;
        this._parentContainer = parentContainer;
    }

    add() {
        const contentJSON = {
            name: this._name,
            uri: this._uri,
            storageObjectId: this._storageObjectId,
            thumbnailURI: this._thumbnailURI
        };

        return this._fetchParentContainer()
            .then(parentContainer => {
                return ContentAPI.createContent(
                    this._project.id,
                    parentContainer.id,
                    contentJSON
                );
            })
            .then(contentJSON => {
                const contentFactory = new ContentFactory(this._project);
                return contentFactory.build(contentJSON);
            })
            .then(content => {
                return ContentRepository.find(this._project).add(content);
            });
    }

    _fetchParentContainer() {
        const project = this._project;

        if (this._parentContainer === 'attachments') {
            return ContainerRepository.find(project)
                .fetchRootOnce()
                .then(rootContainer => {
                    return ContainerRepository.find(project)
                        .fetchChildContainersOnce(rootContainer)
                        .then(containers => {
                            const attachmentsContainer = containers.find(c => {
                                return c.isSystem() && c.getSystemName() === 'attachments';
                            });
                            // attachments という名前のシステムフォルダが見つからなければ、 root に fallback する
                            return attachmentsContainer || rootContainer;
                        });
                });
        }

        // 親となるContainerが見つからない場合、 rootContainer に fallback する
        return ContainerRepository.find(project).fetchRootOnce();
    }
}

class ContentUpdateService {
    constructor(project, content, contentJSON){
        this._project = project;
        this._content = content;
        this._contentJSON = contentJSON;
    }

    update() {
        return ContentRepository.find(
            this._project
        ).update(
            this._content, this._contentJSON
        );
    }
}

class ContentDeleteService {
    constructor(project, content){
        this._project = project;
        this._content = content;
    }

    delete() {
        return ContentRepository.find(
            this._project
        ).deleteContent(
            this._content
        );
    }
}

module.exports = {
    ContentAddService: ContentAddService,
    ContentUpdateService: ContentUpdateService,
    ContentDeleteService: ContentDeleteService
};



// WEBPACK FOOTER //
// ./data/app/service/content/index.js